import { useLocation } from 'react-router-dom';

export const GetURLQuery = (
  attribName,
  returnSearch = false
) => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const data =
    query.get(`${attribName}`)?.toString() ?? null;

  const secrectUrl = location.search.substring(1); // remove the leading '?'

  return returnSearch ? secrectUrl : data;
};
